var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUsage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 16,
  y: 9,
  width: 2,
  height: 11,
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 13,
  y: 12,
  width: 2,
  height: 8,
  rx: 1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  y: 7,
  width: 2,
  height: 13,
  rx: 1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 3,
  width: 2,
  height: 17,
  rx: 1
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 19,
  width: 1,
  height: 20,
  rx: 0.5,
  transform: "rotate(90 21 19)"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 13,
  width: 2,
  height: 7,
  rx: 1
})));
export default SvgUsage;